import React, { useState } from "react";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faHome,
  faBuilding,
  faAirFreshener,
  faInbox,
  faImage,
  faTools,
  faGhost,
} from "@fortawesome/free-solid-svg-icons";

import "../nav-bar/NavBar.scss";

const NavBar = () => {
  const [authenticate, setAuthenticate] = useState(false);

  const login = () => {
    setAuthenticate(true);
  };
  return (
    <>
      <div className="navbar">
        <div className="navbar__navbar-logo-container">
          <Link to="/">
            <img
              className="navbar__logo"
              alt="logo"
              src={require("../mobile-header/mob-logo.png")}
              alt="desktop-logo"
            />
          </Link>
        </div>
        <nav className="navbar__nav-list">
          <ul className="navbar__navbar-items">
            {/* <FontAwesomeIcon icon={faBars} />
          <li className="navbar-items__menu">Menu</li> */}
            <FontAwesomeIcon icon={faHome} />

            <li className="navbar-items__home">
              <Link to="/">Home</Link>
            </li>

            <FontAwesomeIcon icon={faBuilding} />
            <li>Community</li>
            <FontAwesomeIcon icon={faAirFreshener} />
            <li>Discover</li>
            <FontAwesomeIcon icon={faInbox} />
            <li>Coming Soon</li>
            {/* <FontAwesomeIcon icon={faPersonBooth} /> */}
            {/* <li>Friends</li>
          <FontAwesomeIcon icon={faStar} />
          <li>Parties</li> */}
            <FontAwesomeIcon icon={faImage} />
            <li>Media</li>
            <FontAwesomeIcon icon={faTools} />
            <li>Setting</li>
            {authenticate ? (
              <>
                <FontAwesomeIcon icon={faGhost} />
                <li
                  onClick={() => {
                    setAuthenticate(false);
                  }}
                >
                  Log Out
                </li>
              </>
            ) : (
              <>
                <FontAwesomeIcon icon={faGhost} />
                <li onClick={login}>Log In</li>
              </>
            )}
          </ul>
        </nav>
      </div>
    </>
  );
};
export default NavBar;
